import { v4 as uuid } from 'uuid';
import { apiUploadImg } from '@/utils/requests/common/oss';
import { apiGetTempUploadUrl } from '@/services/OssRequest';
import axios from 'axios';
import * as path from 'path';

// 上传图片
export const onImageUpload = async (options: any) => {
  const result = await apiUploadImg('cmap/study', options.file);
  if (result.code === 200) {
    options.onSuccess?.({
      success: true,
      data: { id: uuid(), url: result.data },
    });
  }
};

// 上传视频&附件
export const onFileAndVideoUploadOld = async (options: any) => {
  const result = await apiUploadImg('cmap/study', options.file);
  if (result.code === 200) {
    options.onSuccess?.({
      success: true,
      data: {
        id: uuid(),
        url: result.data,
        downloadUrl: result.data,
      },
    });
  }
};

// 上传视频&附件
export const onFileAndVideoUpload = async (option: any) => {
  const file = option.file as File;
  const uploadFileName = uuid().replace('-', '') + path.extname(file.name);
  const tempUrl = await apiGetTempUploadUrl({
    path: 'myfr/cert/pic',
    fileName: uploadFileName,
    contentType: file.type,
  });
  if (tempUrl.data.signedUrl) {
    const {
      data: { signedUrl, actualSignedRequestHeaders },
    } = tempUrl;
    axios
      .request({
        method: 'PUT',
        url: signedUrl,
        withCredentials: false,
        headers:
          Object.assign(actualSignedRequestHeaders, {
            'Content-Disposition': `attachment; filename=${encodeURIComponent(file.name)}`,
          }) || {},
        data: file,
      })
      .then(() => {
        const uploadUrl = `https://shequ-oss.obs.cn-east-2.myhuaweicloud.com:443/myfr/cert/pic/${uploadFileName}`;
        option.onSuccess?.({
          success: true,
          data: {
            id: uuid(),
            url: uploadUrl,
            downloadUrl: `myfr/cert/pic/${uploadFileName}`,
          },
        });
      })
      .catch(() => {
        // option.onError?.('上传失败请稍后重试');
      });
  } else {
    // option.onError?.('上传失败请稍后重试');
  }
};
